import { BagsSubForm } from './BagsSubForm';
import { BasicParametersSubForm } from './BasicParametersSubForm';
import { CrowdSubForm } from './CrowdSubForm';
import { DroiForm } from './DroiForm';
import { EventPolicySubForm } from './EventPolicySubForm';
import { FacecoverSubForm } from './FacecoverSubForm';
import { FallSubForm } from './FallSubForm';
import { FightSubForm } from './FightSubForm';
import { FireSubForm } from './FireSubForm';
import { HandsupSubForm } from './HandsupSubForm';
import { LyingSubForm } from './LyingSubForm';
import { RestartOptionsSubForm } from './RestartOptionsSubForm';
import { StreamDataSubForm } from './StreamDataSubForm';
import { TargetsOverviewSubForm } from './TargetsOverviewSubForm';
import { WeaponSubForm } from './WeaponSubForm';

export const SubForms = {
  CrowdSubForm,
  BasicParametersSubForm,
  StreamDataSubForm,
  RestartOptionsSubForm,
  EventPolicySubForm,
  FightSubForm,
  FireSubForm,
  FacecoverSubForm,
  FallSubForm,
  TargetsOverviewSubForm,
  WeaponSubForm,
  BagsSubForm,
  LyingSubForm,
  HandsupSubForm,
  DroiForm,
};
